// removed by extract-text-webpack-plugin
module.exports = {"layout":"_21c49","header":"_04dab","subhead":"_0b728","note":"d3342","content":"_6d3df","footer":"_84c3e"};


//////////////////
// WEBPACK FOOTER
// ./src/Layouts/styles/layout.css
// module id = 136
// module chunks = 0